import WarningIcon from '@mui/icons-material/Warning';
import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        width: '18.75rem',
        height: '20rem',
        padding: theme.spacing(0.5),
    },
    icon: {
        color: '#6f52ed',
        fontSize: '8rem',
    },
}));

export default function PageError() {
    const { classes } = useStyles();

    return (
        <Grid
            container
            direction="column"
            wrap="nowrap"
            alignItems="center"
            justifyContent="center"
            spacing={1}
            className={classes.root}
        >
            <Grid item xs="auto">
                <WarningIcon className={classes.icon} />
            </Grid>
            <Grid item xs="auto">
                <Typography component="p" variant="h4" align="center">
                    Something Went Wrong!
                </Typography>
            </Grid>
            <Grid item xs="auto">
                <Typography component="p" align="center">
                    We're going to try again. If this persists, please refresh your page.
                </Typography>
            </Grid>
        </Grid>
    );
}
